// Конфигурация API клиента.
// SECURITY: frontend contains no secrets; auth enforced on backend. API URL from origin or VITE_API_URL only (no hardcoded production domain).
const getApiUrl = () => {
  const envUrl = import.meta.env.VITE_API_URL;
  if (typeof window !== 'undefined') {
    const { protocol, origin, host } = window.location;
    if (protocol === 'http:' || protocol === 'https:') {
      return envUrl || origin;
    }
    if (host) {
      return envUrl || `https://${host}`;
    }
  }
  return envUrl || '';
};

const API_URL = getApiUrl();

export const apiConfig = {
  baseURL: API_URL,
  timeout: 20000,
  headers: {
    'Content-Type': 'application/json',
  },
};

// Экспорт для использования в axios или fetch
export default apiConfig;
